'use client';
import { IContanctInfo_SELL, ISpecificContactTime } from '@/types';
import { useForm } from 'react-hook-form';
import Typography from '@/components/shared/typography/typography.component';
import { useTranslation } from '@/hook';
import SellCarOtp from '../../otp/otp.component';
import { useEffect, useState } from 'react';
import { LoadingButton } from '@mui/lab';
// import { LockIcon } from '../../../../../public/Images';

import styles from './styles.module.scss';
import CustomCheckBox, {
    CheckBoxVariants,
} from '@/components/shared/custom-check-box/custom-check-box.component';
import useAuth from '@/hook/use-auth.hook';
import {
    emailValidationPattern as emailPattern,
    validNumberRegex,
    mobileValidationPattern,
} from '@/constants/validations';
import { translateNumbers } from '@/utils';
import { useSendOtpMutation } from '@/hook/slices/otp-api-slice';
import {
    useValidateAndAddNewContactMutation,
    useValidateAndLoginMutation,
} from '@/hook/slices/user-api-slice';
import { FEATURE_FLAG_NEW_CONTACT } from '@/constants';
interface IFormValues {
    Name: string;
    Number: string;
    Email: string;
    ExtraPhone: string;
    ExtraName: string;
}

const ContactInfoForm = ({
    step,
    formFunction,
    path,
    isError,
    errorMessage,
    isLoading,
}: {
    step: 'contactInfo';
    formFunction: (
        key: 'contactInfo',
        contactInfo: IContanctInfo_SELL,
        otp: string,
        specificTime: ISpecificContactTime
    ) => void;
    path: 'path1' | 'path2';
    isError: boolean;
    errorMessage: any;
    isLoading: boolean;
}) => {
    const { t, IS_RTL } = useTranslation();
    const {
        isLoggedIn,
        name: userName,
        phone: userPhone,
        email: userEmail,
        userId,
        signInRetailCheckout,
    } = useAuth();
    const [sendOTP] = useSendOtpMutation();
    const [
        validateAndAddContact,
        {
            data: validateAndAddContactData,
            error: validateAndAddContactError,
            isLoading: isValidateAndAddContactLoading,
        },
    ] = useValidateAndAddNewContactMutation();
    const [
        validateAndLogin,
        {
            data: validateAndLoginData,
            error: validateAndLoginError,
            isLoading: isValidateAndLoginLoading,
        },
    ] = useValidateAndLoginMutation();
    const {
        register,
        handleSubmit,
        getValues,
        formState: { errors },
        watch,
        setValue,
    } = useForm<IFormValues>();

    const values = watch();
    const { ExtraPhone, ExtraName, Name, Number, Email } = values;
    const [showOTP, setShowOtp] = useState(false);
    const [buttonText, setButtonText] = useState('');
    const [phoneNumberValid, setPhoneNumberValid] = useState(false);
    const [otpValue, setOtpValue] = useState('');
    const [isCheckedNewContact, setCheckedNewContact] =
        useState<boolean>(false);
    const [disableFormBtn, setDisableFormBtn] = useState<boolean>(true);
    const [localErrorMessage, setLocalErrorMessage] = useState<string>('');

    const InputFields = {
        name: {
            id: 'Name' as keyof IFormValues,
            label: t('name'),
            required: true,
            pattern:
                /^[\u0600-\u065F\u066A-\u06EF\u06FA-\u06FFa-zA-Z\s]+[\u0600-\u065F\u066A-\u06EF\u06FA-\u06FFa-zA-Z-_\s]*$/,
            maxLength: 255,
        },
        mobile: {
            id: 'Number' as keyof IFormValues,
            label: t('phone'),
            register: { register },
            required: true,
            pattern: mobileValidationPattern,
        },
        email: {
            id: 'Email' as keyof IFormValues,
            label: t('Email (Optional)'),
            required: false,
            pattern: emailPattern,
        },
        extraName: {
            id: 'ExtraName' as keyof IFormValues,
            label: t('name'),
            required: true,
            pattern:
                /^[\u0600-\u065F\u066A-\u06EF\u06FA-\u06FFa-zA-Z\s]+[\u0600-\u065F\u066A-\u06EF\u06FA-\u06FFa-zA-Z-_\s]*$/,
            maxLength: 255,
        },
        extraMobile: {
            id: 'ExtraPhone' as keyof IFormValues,
            label: t('phone'),
            register: { register },
            required: true,
            pattern: mobileValidationPattern,
        },
    };
    const onSubmit = (data: IFormValues) => {
        setLocalErrorMessage('');
        if (buttonText === t('verify otp')) {
            if (isLoggedIn && isCheckedNewContact) {
                if (showOTP) {
                    const body = {
                        otp: otpValue,
                        name: data.ExtraName,
                        phone: data.ExtraPhone,
                        userId,
                    };
                    validateAndAddContact(body);
                } else {
                    sendOTP(data.ExtraPhone);
                    setShowOtp(true);
                    setButtonText(t('verify otp'));
                    return;
                }
            } else {
                if (showOTP) {
                    const body = {
                        otp: otpValue,
                        name: data.Name,
                        phone: data.Number,
                        email: data.Email,
                    };
                    validateAndLogin(body);
                }
            }
        }

        if (buttonText === t('get OTP')) {
            let targetPhone: string;
            if (isLoggedIn && isCheckedNewContact) {
                targetPhone = data.ExtraPhone;
            } else {
                targetPhone = data.Number;
            }
            if (!showOTP) {
                sendOTP(targetPhone);
                setShowOtp(true);
                setButtonText(t('verify otp'));
            }
            return;
        }
        if (buttonText === t('Submit')) {
            if (isLoggedIn) {
                if (isCheckedNewContact && showOTP) {
                    // console.log('data', data);
                    // const body = {
                    //     otp: otpValue,
                    //     name: data.ExtraName,
                    //     phone: data.ExtraPhone,
                    //     userId,
                    // };
                    // validateAndAddContact(body);
                } else {
                    const contanctInfoObj: IContanctInfo_SELL = {
                        name: data.Name,
                        phone: data.Number,
                        email: data.Email,
                        userId,
                    };
                    formFunction(step, contanctInfoObj, otpValue, {});
                }
            } else {
                if (path === 'path1') {
                    const contanctInfoObj: IContanctInfo_SELL = {
                        name: data.Name,
                        phone: data.Number,
                        email: data.Email,
                        userId,
                    };
                    formFunction(step, contanctInfoObj, otpValue, {});
                    return;
                } else {
                    const contanctInfoObj: IContanctInfo_SELL = {
                        name: data.Name,
                        phone: data.Number,
                        email: data.Email,
                    };
                    formFunction(step, contanctInfoObj, otpValue, {});
                    return;
                }
            }
        }
    };
    const checkValidNumber = (value: string) => {
        const validNumber = mobileValidationPattern.test(value);
        if (validNumber) setPhoneNumberValid(true);
        else setPhoneNumberValid(false);
        if (value !== getValues().Number) {
            if (path == 'path1') setButtonText(t('get OTP'));
            setShowOtp(false);
            setOtpValue('');
        }
    };
    const checkBoxClicked = () => {
        if (isCheckedNewContact) {
            setButtonText(t('Submit'));
            setDisableFormBtn(false);
            setValue('ExtraName' as keyof IFormValues, '');
            setValue('ExtraPhone' as keyof IFormValues, '');
            setOtpValue('');
            setShowOtp(false);
        } else {
            setButtonText(t('get OTP'));
            setDisableFormBtn(true);
        }
        setCheckedNewContact(!isCheckedNewContact);
    };
    const newPhoneOnChange = e => {
        const value = e.target.value;
        if (validNumberRegex.test(value) || value === '') {
            setValue('ExtraPhone', translateNumbers(e.target.value));
        }
    };
    const executeBasicValidationLogic = () => {
        if (isLoggedIn) {
            setDisableFormBtn(false);
        } else {
            const phoneValue = getValues().Number;
            const validNumber = mobileValidationPattern.test(phoneValue);
            setDisableFormBtn(true);
            if (validNumber) {
                setPhoneNumberValid(true);
                setDisableFormBtn(false);
            }
        }
    };
    const executeAdvancedValidationLogicName = () => {
        if (isCheckedNewContact) {
            const nameValue = getValues().ExtraName;
            if (!nameValue || (nameValue && nameValue.length == 0)) {
                setDisableFormBtn(true);
                setButtonText(t('get OTP'));
                if (showOTP) setShowOtp(false);
            } else {
                const extraPhoneValue = getValues().ExtraPhone;
                setDisableFormBtn(true);
                if (!extraPhoneValue) return;
                const validNumber =
                    mobileValidationPattern.test(extraPhoneValue);
                if (validNumber && extraPhoneValue.length == 11) {
                    setPhoneNumberValid(true);
                    setDisableFormBtn(false);
                }
            }
        }
    };
    const executeAdvancedValidationLogicPhone = () => {
        if (isCheckedNewContact) {
            const extraPhoneValue = getValues().ExtraPhone;
            setDisableFormBtn(true);
            setButtonText(t('get OTP'));
            setShowOtp(false);
            setOtpValue('');
            if (!extraPhoneValue) return;
            const validNumber = mobileValidationPattern.test(extraPhoneValue);
            if (validNumber && extraPhoneValue.length == 11) {
                setPhoneNumberValid(true);
                setDisableFormBtn(false);
            }
        }
    };
    const executeBookingLogic = ({ name, phone, email, userId }) => {
        const contanctInfoObj: IContanctInfo_SELL = {
            name,
            phone,
            email,
            userId,
        };
        formFunction(step, contanctInfoObj, otpValue, {});
    };
    const localIsLoading =
        isValidateAndAddContactLoading || isValidateAndLoginLoading;

    useEffect(() => {
        if (isLoggedIn) {
            setValue('Name' as keyof IFormValues, userName);
            setValue('Number' as keyof IFormValues, userPhone);
            setValue('Email' as keyof IFormValues, userEmail);
            setButtonText(t('Submit'));
            setDisableFormBtn(false);
        } else {
            if (path === 'path1') {
                setButtonText(t('get OTP'));
            } else {
                setButtonText(t('Submit'));
            }
        }
    }, [isLoggedIn]);
    useEffect(() => {
        executeBasicValidationLogic();
    }, [Name, Number, Email]);
    useEffect(() => {
        executeAdvancedValidationLogicPhone();
    }, [ExtraPhone]);
    useEffect(() => {
        executeAdvancedValidationLogicName();
    }, [ExtraName]);

    useEffect(() => {
        if (validateAndAddContactData?.statusCode == 201) {
            executeBookingLogic({
                name: values.ExtraName,
                phone: values.ExtraPhone,
                email: values.Email,
                userId,
            });
        }
        if (validateAndAddContactError) {
            const data =
                'data' in validateAndAddContactError
                    ? (validateAndAddContactError.data as { message: string })
                    : null;
            const errorMessage = data?.message;
            if (errorMessage && errorMessage.includes('OTP_DOES_NOT_MATCH!')) {
                setLocalErrorMessage(t('please enter correct OTP'));
            }
        }
    }, [validateAndAddContactData, validateAndAddContactError]);
    useEffect(() => {
        if (validateAndLoginData?.statusCode == 201) {
            const loginToken = validateAndLoginData?.payload?.data;
            const decodedUserId = signInRetailCheckout(loginToken);
            executeBookingLogic({
                name: values.Name,
                phone: values.Number,
                email: values.Email,
                userId: decodedUserId,
            });
        }
        if (validateAndLoginError) {
            const data =
                'data' in validateAndLoginError
                    ? (validateAndLoginError.data as { message: string })
                    : null;
            const errorMessage = data?.message;
            if (errorMessage && errorMessage.includes('OTP_DOES_NOT_MATCH!')) {
                setLocalErrorMessage(t('please enter correct OTP'));
            }
        }
    }, [validateAndLoginData, validateAndLoginError]);
    return (
        <>
            <form
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                }}
                onSubmit={handleSubmit(onSubmit)}
            >
                {!isCheckedNewContact && (
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '16px',
                            marginBottom: '16px',
                        }}
                    >
                        <div className={styles.input_field_group}>
                            <Typography variant="body2Medium">
                                {InputFields.name.label}
                            </Typography>
                            <input
                                className={styles.input}
                                // @ts-ignore 🚨
                                error={
                                    errors?.Name?.type === 'required' ||
                                    errors.Name?.type === 'pattern' ||
                                    undefined
                                }
                                id={InputFields.name.id}
                                {...register(InputFields.name.id, {
                                    required: InputFields.name.required,
                                    pattern: InputFields.name.pattern,
                                    maxLength: InputFields.name.maxLength,
                                })}
                                disabled={isLoggedIn}
                            />
                            {errors?.Name?.type === 'required' && (
                                <Typography
                                    variant="body2Medium"
                                    style={{ color: '#F04438' }}
                                >
                                    {t('please enter your name')}
                                </Typography>
                            )}
                            {errors?.Name?.type === 'pattern' && (
                                <Typography
                                    variant="body2Medium"
                                    style={{ color: '#F04438' }}
                                >
                                    {t('please Enter a valid name')}
                                </Typography>
                            )}
                        </div>
                        <div className={styles.input_field_group}>
                            <Typography variant="body2Medium">
                                {InputFields.email.label}
                            </Typography>
                            <input
                                className={styles.input}
                                // @ts-ignore 🚨
                                error={
                                    errors.Email?.type === 'required' ||
                                    errors.Email?.type === 'pattern'
                                }
                                id={InputFields.email.id}
                                {...register(InputFields.email.id, {
                                    required: InputFields.email.required,
                                    pattern: InputFields.email.pattern,
                                })}
                            />
                            {errors?.Email?.type === 'pattern' && (
                                <Typography
                                    variant="body2Medium"
                                    style={{ color: '#F04438' }}
                                >
                                    {t('emailInvalid')}
                                </Typography>
                            )}
                        </div>
                        <div className={styles.input_field_group}>
                            <Typography variant="body2Medium">
                                {InputFields.mobile.label}
                            </Typography>
                            <div style={{ position: 'relative' }}>
                                <input
                                    className={`${styles.input} ${
                                        IS_RTL ? styles.mobile_input_rtl : ''
                                    }`}
                                    onChangeCapture={e =>
                                        checkValidNumber(e.currentTarget.value)
                                    }
                                    style={{ width: '100%' }}
                                    type="tel"
                                    // @ts-ignore 🚨
                                    error={
                                        errors.Number?.type === 'required' ||
                                        errors.Number?.type === 'pattern'
                                    }
                                    id={InputFields.mobile.id}
                                    {...register(InputFields.mobile.id, {
                                        required: InputFields.mobile.required,
                                        pattern: InputFields.mobile.pattern,
                                    })}
                                    disabled={isLoggedIn}
                                    placeholder={t('loginPhoneExample')}
                                />
                            </div>
                            {errors?.Number?.type === 'required' && (
                                <Typography
                                    variant="body2Medium"
                                    style={{ color: '#F04438' }}
                                >
                                    {t('please enter your number')}
                                </Typography>
                            )}
                            {errors?.Number?.type === 'pattern' && (
                                <Typography
                                    variant="body2Medium"
                                    style={{ color: '#F04438' }}
                                >
                                    {t('please enter a valid number')}
                                </Typography>
                            )}
                        </div>
                        {showOTP && phoneNumberValid && (
                            <SellCarOtp
                                setOtpValue={setOtpValue}
                                mobile={getValues().Number}
                                errorType=""
                                otpError={false}
                            />
                        )}
                    </div>
                )}
                {isCheckedNewContact && (
                    <div className={styles.placeholderInput}>
                        <span>{userName}</span>
                        <span> , </span>
                        <span>{userPhone}</span>
                    </div>
                )}
                {FEATURE_FLAG_NEW_CONTACT&&
                    isLoggedIn && (
                        <div className={styles.additionalDataContainer}>
                            <div className={styles.checkboxInput}>
                                <CustomCheckBox
                                    selected={isCheckedNewContact}
                                    checkBoxClicked={() => checkBoxClicked()}
                                    variant={CheckBoxVariants.contactInfo}
                                />
                            </div>
                            <Typography
                                variant="body1Medium"
                                component="span"
                                style={{ marginInlineEnd: '10px' }}
                            >
                                {t('addNewContactInformation')}
                            </Typography>
                            <div className={styles.newItemWrapper}>
                                <Typography
                                    variant="captionMedium"
                                    component="span"
                                >
                                    {t('newLabel')}
                                </Typography>
                            </div>
                        </div>
                    )}
                {isCheckedNewContact && (
                    <div className={styles.newContactInfoContainer}>
                        <Typography
                            variant="body2"
                            className={styles.checkboxSubtitle}
                        >
                            {t('addNewContactSubtext')}
                        </Typography>
                        <div className={styles.input_field_group}>
                            <Typography
                                variant="body2Medium"
                                className={styles.label}
                            >
                                {t('your name')}
                            </Typography>
                            <input
                                {...register('ExtraName')}
                                className={styles.input}
                                type="text"
                            />
                        </div>
                        <div className={styles.input_field_group}>
                            <Typography
                                variant="body2Medium"
                                className={styles.label}
                            >
                                {t('your phone number')}
                            </Typography>
                            <input
                                {...register('ExtraPhone', {
                                    minLength: 11,
                                    maxLength: 13,
                                })}
                                className={`${styles.input} ${
                                    errors?.ExtraPhone && styles.erorr
                                }`}
                                type="number"
                                value={values.ExtraPhone}
                                onChange={e => {
                                    newPhoneOnChange(e);
                                }}
                                placeholder={t('loginPhoneExample')}
                            />
                            {errors?.ExtraPhone && (
                                <Typography
                                    variant="body2"
                                    className={styles.inputErrorMessage}
                                >
                                    {t('please enter a valid number')}
                                </Typography>
                            )}
                        </div>
                        {showOTP && phoneNumberValid && (
                            <SellCarOtp
                                setOtpValue={setOtpValue}
                                mobile={getValues().ExtraPhone}
                                errorType=""
                                otpError={false}
                            />
                        )}
                    </div>
                )}

                {isError && (
                    <Typography className={styles.errorMessage}>
                        {errorMessage?.data?.message?.includes(
                            'added before'
                        ) ||
                        errorMessage?.data?.message?.includes('ALREADY_EXISTS')
                            ? `${t('verificationErrorDuplicateEntry')}`
                            : `${t('verificationError')}`}
                    </Typography>
                )}
                {!isError && localErrorMessage && (
                    <Typography className={styles.errorMessage}>
                        {localErrorMessage}
                    </Typography>
                )}

                <LoadingButton
                    disabled={disableFormBtn}
                    style={{
                        height: '48px',
                        fontWeight: '600',
                        marginTop: '16px',
                    }}
                    type="submit"
                    variant="contained"
                    loading={isLoading || localIsLoading}
                >
                    {buttonText}
                </LoadingButton>
            </form>
        </>
    );
};
export default ContactInfoForm;
